import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'

export default {
  namespaced: true,
  state: {
    stream: {
      Id: null,
      PageTitle: null,
      StreamCaption: null,
      StreamCoverImage: null,
      StreamURL: null,
      SubscriptionModule_Id: 0
    }
  },
  getters: {
    Stream: state => state.stream
  },
  mutations: {
    [mutationNames.SET_STREAM] (state, stream) {
      state.stream = stream
    },
    [mutationNames.UPDATE_STREAM] (state, obj) {
      Object.assign(state.stream, obj)
    },
    [mutationNames.UPDATE_STREAM_COVER_IMAGE] (state, selectedImage) {
      Object.assign(state.stream, {
        'StreamCoverImage': selectedImage ? selectedImage.ImageName : null
      })
    }
  },
  actions: {
    updateStreamSettings ({ commit, getters }, payload) {
      commit(mutationNames.UPDATE_STREAM, payload)
    },
    async getStreamModule ({ commit, getters }, SubscriptionModuleId) {
      const response = await api.AppModules.GetStreamInfo(SubscriptionModuleId)
      commit(mutationNames.SET_STREAM, response)
    },
    async updateStreamCoverImage ({ commit, getters }, uploadResponse) {
      await api.AppModules.patchStream(getters.Stream.Id, {
        'StreamCoverImage': uploadResponse ? uploadResponse.ImageName : null
      })
      commit(mutationNames.UPDATE_STREAM_COVER_IMAGE, uploadResponse)
    },
    async saveStreamSettings ({ dispatch, getters }) {
      let StreamClone = Object.assign({}, getters.Stream)
      await api.AppModules.SaveStreamInfo(StreamClone)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/appModules/radioSteram.js